export const FIREBASE = 'FIREBASE';
